// src/components/user/Spare2Tab.jsx
import React from 'react';

function Spare2Tab() {
  return (
    <div className="alert alert-secondary">
      Spare2 tab content placeholder.
    </div>
  );
}

export default Spare2Tab;
